import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Alert, Button, Typography } from '@/components/common';
import Icons from '@/const/icons';

export const UnsuccessfulPhaseBody: React.FC = () => (
	<div className="min-h-[360px] flex flex-col items-center justify-center py-8">
		<div className="w-20 h-20 rounded-full bg-purple-150/10 flex items-center justify-center mb-6">
			<AlertTriangle className="w-8 h-8 text-purple-150" />
		</div>
		<Typography type="semibold-24" className="text-center">
			Verification Unsuccessful
		</Typography>
		<Typography type="regular-16" className="text-center text-gray-35 mt-2">
			We were unable to verify your identity with the information provided. This
			is your final attempt—please review your details carefully before
			resubmitting.
		</Typography>
		<Alert
			type="warning"
			title="What to do next"
			titleClassName="!text-left !text-black"
			className="mt-6 w-full !py-4 !rounded-xl"
			classNameText="!text-black !font-semibold !text-left !text-sm"
			classNameDescription="!text-left"
			description="Please review your personal details for accuracy, then try again. Make sure your name matches your legal name exactly."
		/>
	</div>
);

interface UnsuccessfulPhaseFooterProps {
	onClose: () => void;
	onTryAgain: () => void;
}

export const UnsuccessfulPhaseFooter: React.FC<
	UnsuccessfulPhaseFooterProps
> = ({ onClose, onTryAgain }) => (
	<div className="flex items-center justify-between gap-3">
		<Button decoration="secondary" onClick={onClose} size="fit">
			Close
		</Button>
		<Button
			decoration="primary"
			icon={Icons.refreshAlt}
			iconLeft
			onClick={onTryAgain}
			size="fit"
			label="Try Again"
			classNameButton="!text-white !size-4"
		/>
	</div>
);
